import {createAction} from 'util/redux';
import {CustomFieldTO, KostTO} from 'generated/JavaTO';

const NAMESPACE = 'KOST/'
export const resetKostModelsAction = createAction<KostTO[]>(NAMESPACE + 'reset')
export const setVisibleKostkeysAction = createAction<string[]>(NAMESPACE + 'visible')
export const setKostSingleChoiceModeAction = createAction<boolean>(NAMESPACE + 'singleChoiceMode')
export const setKostFetchedAction = createAction(NAMESPACE + 'setKostFetched')
export const ensureKostsFetchedAction = createAction(NAMESPACE + 'ensureFetched')
export const fetchKostsAction = createAction(NAMESPACE + 'fetchKosts')
export const kostSetLoadingAction = createAction<boolean>(NAMESPACE + 'SetLoading')
export const setKostTemplateStrAction = createAction<string | null | undefined>(NAMESPACE + 'setKostTemplateString')

export const kostAuswertungModalOpenAction = createAction(NAMESPACE + 'ModalOpen')
export const kostAuswertungCFDefResponseAction = createAction<CustomFieldTO[]>(NAMESPACE + 'AuswertungCFDefResponse')
